import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';

export const RichContent = styled.div`
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONTS.RETHINK};

  > :last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  h1 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 16px;
    font-family: ${FONTS.ARTZ};
  }

  h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  h3 {
    font-size: 18px;
    margin-bottom: 8px;
  }

  h4 {
    font-size: 16px;
  }

  p {
    margin: 0 0 16px;
    font-size: inherit;
    line-height: inherit;
  }

  b,
  strong {
    font-weight: 700;
  }

  ul,
  ol {
    margin: 0 0 16px;
    padding: 0;
    font-size: inherit;
    line-height: inherit;
    list-style-position: inside;
  }
`;
